const indexData = [
  { title: '动作大片', desc: '热血刺激的动作电影合集', icon: 'ri-fire-line', count: '2,300+' },
  { title: '科幻世界', desc: '探索未来与未知的科幻之旅', icon: 'ri-rocket-line', count: '1,800+' },
  { title: '喜剧天地', desc: '笑到停不下来的喜剧精选', icon: 'ri-emotion-laugh-line', count: '2,100+' },
  { title: '悬疑剧场', desc: '烧脑刺激的悬疑推理佳作', icon: 'ri-search-eye-line', count: '1,500+' },
  { title: '爱情文艺', desc: '温暖治愈的爱情文艺片精选', icon: 'ri-heart-line', count: '1,600+' },
  { title: '动漫专区', desc: '国漫日漫高分动画全收录', icon: 'ri-artboard-line', count: '3,200+' },
  { title: '纪录片', desc: '真实世界的精彩纪录', icon: 'ri-vidicon-line', count: '900+' },
  { title: '恐怖惊悚', desc: '胆大者的午夜尖叫之选', icon: 'ri-ghost-line', count: '1,100+' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">专题合集</h2>
          <p className="text-sm text-foreground-500 max-w-[560px] mx-auto">按类型精心整理的影视专题，快速定位你感兴趣的内容领域。</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexData.map((item, i) => (
            <div
              key={i}
              className="group flex flex-col items-center text-center p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all mb-3">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-[10px] font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full">{item.count} 部</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}